import { defineComponent as r, computed as l, openBlock as h, createElementBlock as i, createElementVNode as t, toDisplayString as f, createCommentVNode as d, normalizeStyle as n, createStaticVNode as v } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "bf864b7a-eb1e-4f18-973f-8874a926aef2" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#bf864b7a-eb1e-4f18-973f-8874a926aef2)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#ffda44" d="m367.3 256-69.2 69.2a77.9 77.9 0 0 0 138.4 0z"></path><path fill="#6da544" d="M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z"></path><path fill="#496e2d" d="M445.2 256zm-155.8 0z"></path><path fill="#ffda44" d="M311.7 155.8h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm0 50.1h22.2v22.3h-22.2zm89-100.2H423v22.3h-22.3zm0 50.1H423v22.3h-22.3zm0 50.1H423v22.3h-22.3z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#eee" d="M350.6 189.2H384v89h-33.4z"></path><circle cx="367.3" cy="189.2" r="16.7" fill="#a2001d"></circle>', 9), g = { fill: "none" }, z = ["r"], b = /* @__PURE__ */ r({
  __name: "vg",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, a = l(() => 512 + 2 * e.strokeWidth), o = l(() => -e.strokeWidth), c = l(() => 256 + e.strokeWidth / 2);
    return (V, x) => (h(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${a.value} ${a.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (h(), i("title", k, f(e.flagName), 1)) : d("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, p));
  }
});
export {
  b as default
};
//# sourceMappingURL=vg-7e3907d6.js.map
